import { createAction } from '@reduxjs/toolkit';

import type {
  DeleteMcpProfilePayload,
  DeleteMcpServerPayload,
  UpdateMcpConfigPayload,
  UpsertMcpProfilePayload,
  UpsertMcpServerPayload,
} from '@polyai/schemas';

const PREFIX = 'mcpConfig';

export const updateMcpConfig = createAction<UpdateMcpConfigPayload>(
  `${PREFIX}/updateConfig`,
);

export const upsertMcpServer = createAction<UpsertMcpServerPayload>(
  `${PREFIX}/upsertServer`,
);

export const deleteMcpServer = createAction<DeleteMcpServerPayload>(
  `${PREFIX}/deleteServer`,
);

export const upsertMcpProfile = createAction<UpsertMcpProfilePayload>(
  `${PREFIX}/upsertProfile`,
);

export const deleteMcpProfile = createAction<DeleteMcpProfilePayload>(
  `${PREFIX}/deleteProfile`,
);
